import PhoneNumberField from './PhoneNumberField.vue'

export default PhoneNumberField
